import React, { useState } from "react";
import Image from "react-bootstrap/Image";
import moment from "moment";

export const ReferralTableBody = ({
  refuserId,
  refree,
  referalRole,
  refDate,
  enrollDate,
  lastActivity,
  referralQualified,
  amount,
  receivingOrgID,
  receivingOrgName,
  ...props
}) => {
  const [TrDetail, setTrDetail] = useState(false);
  return (
    <React.Fragment>
      <tr
        className="superadmin-referral-table-body"
        onClick={() => setTrDetail(!TrDetail)}
        style={{ wordWrap: "break-word" }}
      >
        <td style={{ width: "10%" }}>#{refuserId}</td>
        <td style={{ width: "15%" }}>{props.referalcode}</td>
        <td style={{ width: "10%" }}>
          {props?.data?.referred_id?._id}
          {/* <div className="section-one-box">
            <div className="image-user-box">
              <Image
                src={refree.src}
                alt="User Pic"
                title="refree User"
                fluid
              />
            </div>
            <h3>{refree.name}</h3>
          </div> */}
        </td>

        <td style={{ width: "10%" }}>{props?.data?.referred_id?.first_name}</td>
        <td style={{ width: "10%" }}>{props?.data?.referred_id_Model}</td>
        <td style={{ width: "10%" }}>
          {moment(new Date(refDate)).format("DD MMM YYYY")}
        </td>
        <td style={{ width: "8%" }}>
          {/* {lastActivity} */}
          Registration
          {/* {moment(enrollDate).format("Qo MMM YYYY")} */}
        </td>
        <td style={{ width: "7%" }}>
          {/* {amount} */}
          {referralQualified}
        </td>
        <td style={{ width: "10%" }}>
          {/* {receivingOrgID} */}
          {moment(new Date(enrollDate)).format("DD MMM YYYY")}
        </td>

        {/* <td style={{ width: "10%" }}> */}
        {/* {receivingOrgName} */}
        {/* </td> */}
      </tr>
      {TrDetail && (
        <tr
          className="superadmin-referral-table-body"
          style={{ wordWrap: "break-word" }}
        >
          <td style={{ width: "18%" }}>
            <div className="f12-500">
              Payable Amount <br />
              To Referrer
            </div>
            <div className="f12-400">₹ {props?.data?.amount_disbursement}</div>
          </td>
          <td style={{ width: "18%" }}>
            <div className="f12-500">
              Payable Amount <br />
              To Referee
            </div>
            <div className="f12-400">₹ {props?.data?.amount_disbursement}</div>
          </td>
          <td style={{ width: "18%" }}>
            <div className="f12-500">
              Contribution towards
              <br /> Udbhav
            </div>
            <div className="f12-400">₹ 5</div>
          </td>
        </tr>
      )}
    </React.Fragment>
  );
};
